<button mat-button [matMenuTriggerFor]="menu">
  <span class="user-info">
    <span>
      <span>{{ user?.fullName }} ({{ authService.role }})</span>
      <span>{{ user?.email }}</span>
    </span>
    <kis-username-icon [name]="user?.fullName"></kis-username-icon>
  </span>
</button>

<mat-menu #menu="matMenu" xPosition="before">
  <a mat-menu-item routerLink="/app/config" *ngIf="canSeeConfig">
    <mat-icon fontSet="fa" fontIcon="fa-cog"></mat-icon>
    Configuration
  </a>
  <button mat-menu-item (click)="storage.get('oauth_token') ? authService.logoutFromMicrosoft() : authService.logout()">
    <mat-icon fontSet="fa" fontIcon="fa-sign-out-alt"></mat-icon>
    Logout
  </button>
</mat-menu>
